module.exports = __webpack_public_path__ + "static/media/torn-v@2x.ad2796cf.png";